import React from "react";
import { string, number } from "prop-types";

const PhotoIcon = ({ color = "#FFF", width = 30, height = 28 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h25.043v24H0z" />
      <path
        fill={color}
        fillRule="nonzero"
        d="M18.125 16.563c0 .364-.128.674-.383.93a1.266 1.266 0 0 1-.93.382h-10.5c-.364 0-.674-.128-.93-.383a1.266 1.266 0 0 1-.382-.93v-7c0-.364.128-.674.383-.93.255-.254.565-.382.93-.382h.437v5.688c0 .601.214 1.116.643 1.544.428.429.943.643 1.544.643h9.188v.438zm2.625-2.625c0 .364-.128.674-.383.93a1.266 1.266 0 0 1-.93.382h-10.5c-.364 0-.674-.128-.93-.383a1.266 1.266 0 0 1-.382-.93v-7c0-.364.128-.674.383-.93.255-.254.565-.382.93-.382h10.5c.364 0 .674.128.93.383.254.255.382.565.382.93v7zM12 8.25c0-.365-.128-.674-.383-.93a1.266 1.266 0 0 0-.93-.382c-.364 0-.674.127-.93.382a1.266 1.266 0 0 0-.382.93c0 .365.128.674.383.93.255.255.565.383.93.383.364 0 .674-.128.93-.383.254-.256.382-.565.382-.93zm-2.625 3.938V13.5H19v-3.062L16.594 8.03a.296.296 0 0 0-.219-.082.296.296 0 0 0-.219.082l-3.719 3.719-1.093-1.094a.296.296 0 0 0-.219-.082.296.296 0 0 0-.219.082l-1.531 1.532z"
      />
    </g>
  </svg>
);

PhotoIcon.propTypes = {
  color: string,
  width: number,
  height: number
};

export default PhotoIcon;
